import { render, staticRenderFns } from "./panduan.vue?vue&type=template&id=02b25573&scoped=true"
import script from "./panduan.vue?vue&type=script&lang=js"
export * from "./panduan.vue?vue&type=script&lang=js"
import style0 from "./panduan.vue?vue&type=style&index=0&id=02b25573&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02b25573",
  null
  
)

export default component.exports